import { forwardRef, useState } from "react";
import { useGetActivitiesByCollectionQuery } from "services/collections.service";
import ScrollableSection, { type sectionDataType } from "components/scrollableSection/scrollableSection";
import "./collection.scss"
import { stripHtml } from "utils/text.util";
import { useSelector } from "react-redux";
import { CloseButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
interface CollectionProps {
    section: sectionDataType;
    idx: number;
    isMobile: boolean;
    isSelected: boolean;
    onToggle: (id: string) => void;
}

const Collection = forwardRef<HTMLDivElement, CollectionProps>(
    ({ idx, section, isMobile, isSelected, onToggle }, ref) => {
        const [offset, setOffset] = useState(0);
        const searchValue: string = useSelector((state: any) => state.titleBar.searchValue);
          const { t } = useTranslation();

        const { data: res, isFetching: isFetchingResources } = useGetActivitiesByCollectionQuery(
            {
                collectionId: section.sectionId,
                limit: 50,
                keywords: searchValue,
                offset
            },
            { skip: !isSelected });
        
        const handleClick = () => onToggle(section.sectionId);

        return (
            <div className={`collection section-${idx % 10} ${isSelected ? 'fullSize' : 'cardSize'}`} onClick={() => isSelected ? false : handleClick()}>
                <div className="collection__description">
                    <div className="collection__img">
                        <img src={section.img} />
                    </div>
                    <div className="collection__data">
                        {isSelected && <CloseButton onClick={handleClick}/>}
                        <h5>{section.sectionName}</h5>

                        <p>{stripHtml(section.description ?? "")}</p>
                    </div>
                </div>

                {isSelected && <ScrollableSection
                    key={idx}
                    id={section.sectionId}
                    idx={idx}
                    title={`${t("collectionResources")} : ${res?.count ?? '-'}`}
                    isScrollable={false}
                    isSeeMore={true}
                    items={res?.resources}
                    isMobile={isMobile}
                    isLoading={isFetchingResources}
                    hideSeeMoreButton={true}
                    isPagination={res && res?.count > 0}
                    hasPrev={offset >= 50}
                    hasNext={res && (offset + 50) < res?.count}
                    paginateNext={() => setOffset(offset + 50)}
                    paginatePrev={() => setOffset(offset - 50)}
                    paginationInfo={`${t("page")} ${offset/50 + 1} ${t("on")} ${Math.ceil((res?.count ?? 0)/50)}`}
                />}

            </div>

        );
    }
);

export default Collection;